import styled from 'styled-components';

export const PartyJackpotWelcomePopupSeparatorBox = styled.div`
    border-top: 1px solid ${({theme}) => theme.colors.textLight};
    padding-top: 40px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-top: 30px;

        @media ${({theme}) => theme.mediaQuery.landscape} {
            padding-top: 15px;
        }
    }
`;
